(window["webpackJsonp_N_E"] = window["webpackJsonp_N_E"] || []).push([[248],{

/***/ "cmoa":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXTERNAL MODULE: /opt/webapp/node_modules/@babel/runtime/helpers/esm/extends.js
var esm_extends = __webpack_require__("cxan");

// EXTERNAL MODULE: /opt/webapp/node_modules/@babel/runtime/helpers/esm/objectWithoutProperties.js
var objectWithoutProperties = __webpack_require__("HbGN");

// EXTERNAL MODULE: /opt/webapp/node_modules/react/index.js
var react = __webpack_require__("ERkP");
var react_default = /*#__PURE__*/__webpack_require__.n(react);

// EXTERNAL MODULE: ./src/client/tracking/tracking-api/useTracking.js
var useTracking = __webpack_require__("sRdV");

// EXTERNAL MODULE: ./src/utils/graphql-client/use-gql/useGQL.js
var useGQL = __webpack_require__("0JpG");

// EXTERNAL MODULE: ./src/utils/request/requestDictionary.js
var requestDictionary = __webpack_require__("CcNa");

// EXTERNAL MODULE: ./src/utils/use-gql-errors-handler/useGQLErrorsHandler.js
var useGQLErrorsHandler = __webpack_require__("Kl3I");

// EXTERNAL MODULE: ./src/client/components/frameworks/site-container/SiteContainer.jsx
var SiteContainer = __webpack_require__("ZNfd");

// EXTERNAL MODULE: ./src/client/components/frameworks/spinner/Spinner.jsx
var Spinner = __webpack_require__("7amT");

// EXTERNAL MODULE: ./src/client/components/widgets/facilities-hours/FacilitiesHours.jsx + 2 modules
var FacilitiesHours = __webpack_require__("H8O8");

// EXTERNAL MODULE: ./src/client/components/widgets/line-title/LineTitle.jsx
var LineTitle = __webpack_require__("2Ufl");

// EXTERNAL MODULE: ./src/utils/graphql/index.js
var graphql = __webpack_require__("NLwV");

// CONCATENATED MODULE: ./src/client/components/lines/qrcode-product-bars-line/QRCodeProductBarsLine.utils.js

var QRCodeProductBarsLine_utils_getProductBarsQuery = function getProductBarsQuery(productId) {
  var productArgs = Object(graphql["c" /* buildProductArgs */])(productId);
  return "\n  query {\n    resort(".concat(productArgs, ") {\n      facilities(types: [\"BARS\"]) {\n        additionalDescription\n        id\n        images\n        label\n        menu {\n          label\n          href\n        }\n        openingDays {\n          businessHours {\n            closing\n            label\n            opening\n          }\n          day\n        }\n        reservationLink\n        subtitle\n        type\n      }\n    }\n  }");
};
// CONCATENATED MODULE: ./src/client/components/lines/qrcode-product-bars-line/QRCodeProductBarsLine.jsx


var __jsx = react_default.a.createElement;










var QRCodeProductBarsLine_QRCodeProductBarsLine = function QRCodeProductBarsLine(_ref) {
  var _data$resort;

  var resortId = _ref.resortId,
      title = _ref.title,
      rest = Object(objectWithoutProperties["a" /* default */])(_ref, ["resortId", "title"]);

  // Implementation carried on the component side to correct the problem of the timezone of the resort
  var _useGQL = Object(useGQL["a" /* useGQL */])({
    query: QRCodeProductBarsLine_utils_getProductBarsQuery(resortId),
    queryOptions: {
      requestName: requestDictionary["fc" /* LINE_QRCODE_PRODUCT_BARS */],
      cacheFront: {
        key: requestDictionary["fc" /* LINE_QRCODE_PRODUCT_BARS */] + resortId
      }
    },
    cache: false,
    ignore: !resortId
  }),
      isLoading = _useGQL.isLoading,
      data = _useGQL.data,
      error = _useGQL.error;

  Object(useGQLErrorsHandler["a" /* useGQLErrorsHandler */])(error, {
    catchAuthError: true
  });
  var track = Object(useTracking["a" /* useTracking */])({
    actionGA: 'Bar & Restaurant',
    categoryGA: 'landing'
  });

  if (!resortId) {
    return null;
  }

  var facilities = (data === null || data === void 0 ? void 0 : (_data$resort = data.resort) === null || _data$resort === void 0 ? void 0 : _data$resort.facilities) || [];
  return __jsx(SiteContainer["a" /* SiteContainer */], {
    className: "Line",
    "data-testid": "qrcode-product-bars",
    size: "small"
  }, __jsx(LineTitle["a" /* LineTitle */], null, title), isLoading ? __jsx("div", {
    className: "flex justify-center items-center"
  }, __jsx(Spinner["a" /* Spinner */], {
    size: "small"
  })) : __jsx(FacilitiesHours["a" /* FacilitiesHours */], Object(esm_extends["a" /* default */])({}, rest, {
    facilities: facilities,
    onFacilityClick: function onFacilityClick() {
      return track({
        labelGA: 'book a table'
      });
    },
    onTabClick: function onTabClick() {
      return track({
        labelGA: 'tabs'
      });
    }
  })));
};
// CONCATENATED MODULE: ./src/client/cms/toolkit/qrcode-product-bars/descriptor.js

/* harmony default export */ var descriptor = __webpack_exports__["default"] = (QRCodeProductBarsLine_QRCodeProductBarsLine);

/***/ })

}]);